import { useProfile } from './hooks/useProfile';
import ProfileView from './view';

// Public user profile — `/profile` (me, no handle) and `/@handle` (anyone; the
// handle arrives from SlugRoute). The hook owns loading, ownership and
// actions; the view only lays out.
export default function Profile({ handle }) {
    const props = useProfile(handle);
    return <ProfileView {...props} />;
}
